<template>
  <div
    :id="id"
    class="rs-inline-form"
  >
    <div class="row m-0">
      <div class="label-container">
        <!-- label col is 25% width? -->
        <slot name="extraTopLabel" />
        <label>
          {{ label }}
          <sup v-if="required">*</sup>
          <span v-if="helpTooltip">
            <RsIcon
              :id="`helperTooltip-${id}`"
              icon="question-circle"
              class="tooltip-question-icon"
            />
            <RsTooltip
              :target="`helperTooltip-${id}`"
              :title="helpTooltip"
              :position="helpTooltipPosition"
              :delay="{ show: 200 }"
            />
          </span>
        </label>

        <slot
          class="d-inline"
          name="labelDecor"
        />
      </div>
      <div class="form-container col">
        <div class="row m-0 align-items-center h-100 w-100">
          <!-- form slot is 75% width? -->
          <div class="col-12 p-0">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import type { TTooltipPosition } from '@/shared/types';

export default defineComponent({
  name: 'RsInlineForm',

  props: {
    id: {
      type: String,
      required: true,
    },

    label: {
      type: String,
      required: true,
    },

    required: {
      type: Boolean,
      required: false,
      default: false,
    },

    helpTooltip: {
      type: String,
      required: false,
    },

    helpTooltipPosition: {
      type: String as PropType<TTooltipPosition>,
      required: false,
      default: 'top',
    },

  },
});
</script>

<style lang="scss">
@import '@/styles/_variables.scss';

$label-container-width: 145px;
$label-container-bg: #F5F6Fb;

.rs-inline-form {
  min-height: 48px;
  border: solid 1px $border-color;

  * {
    line-height: 1;
  }

  /* Handle nested cases */
  .rs-inline-form {
    margin: 0 -21px 0 -21px;
    transition: none;
  }

  .label-container {
    width: $label-container-width;
    padding: 16px 20px;
    background: $label-container-bg;
    border-right: solid 1px $border-color;
    label {
      font-size: 14px;
      margin-bottom: 0;
    }
  }

  .inline-nested-margin {
    margin: 0 -21px 0 -21px;
  }

  input.form-control {
    background-color: #fefefe !important;
    border-radius: 6px !important;
    border: 1px solid #c9ccdf;
    color: #0a0a0a;
    font-size: 0.9375rem;
    box-sizing: border-box;
    height: 32px !important;
    padding: 0.25rem 0.5rem 0.25rem 0.5rem;
    &.is-invalid {
      border-color: #DC3545;
    }
  }

  select.form-control, select.custom-select {
    border-radius: 6px !important;
    border: 1px solid #c9ccdf !important;
    font-size: 0.9375rem;
    color: #0a0a0a;
    padding: 0rem 1.5rem 0rem 0.5rem !important;
    height: 32px !important;
  }

  .form-control:disabled {
    background-color: $input-disabled-gray !important;
  }

  .form-container {
    background: $white;
    padding: 8px;

    .rs-select label, .rs-input label{
      display: none;
    }

    input, select, button {
      height: 32px;
    }

    button {
      padding: 4px 10px;
    }

    .rs-select, .rs-input, .rs-form-tiptap, textarea {
      margin-bottom: 0 !important;
    }
  }
}

</style>
